export const VIEW_MODE = {
  CARD: 'CARD',
  LIST: 'LIST',
}
